import { gql } from '@apollo/client'

export const PROVIDERS_QUERY = gql`
  query Providers($showLog: Boolean) {
    providers(showLog: $showLog) {
      id
      name
      nameTranslatedList {
        label
        nativeLabel
        value
      }
      providerCode
      displayProviderCode
    }
  }
`

export const PROVIDER_QUERY = gql`
  query Provider($providerCode: String!) {
    provider(providerCode: $providerCode) {
      id
      providerCode
      displayProviderCode
      name
      nameTranslatedList {
        label
        nativeLabel
        value
      }
      slogan
      hostName
      rateGroupName
      rateGroupNameTranslatedList {
        label
        nativeLabel
        value
      }
      rateGroupCode
    }
  }
`

export const PROVIDER_NAME_QUERY = gql`
  query ProviderName($providerCode: String!) {
    providerName(providerCode: $providerCode) {
      name
    }
  }
`
